import type { RouteRecordRaw } from 'vue-router';

export default {
  meta: { feature: 'databases' },
  path: 'iaas/databases/create/',
  name: 'database/create',
  component: () => import('@/views/dashboard/iaas/databases/create/index.vue'),
} satisfies RouteRecordRaw;
